@if (label()) {
  <label [for]="inputId">{{ label() }} </label>
}

@if (type() === 'single') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input
      matInput
      [matDatepicker]="picker"
      [placeholder]="placeholder()"
      [id]="inputId"
      [min]="min()"
      [max]="max()"
      [disabled]="disabled"
      [value]="value"
      (dateChange)="onDateChange($event)"
      (blur)="handleBlur()"
    />

    <mat-datepicker-toggle matIconSuffix [for]="picker" />

    <mat-datepicker #picker />
  </mat-form-field>
} @else {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-date-range-input [rangePicker]="rangePicker" [min]="min()" [max]="max()">
      <input
        matStartDate
        [formControl]="startDateControl"
        placeholder="Start date"
        (blur)="handleBlur()"
      />

      <input
        matEndDate
        [formControl]="endDateControl"
        placeholder="End date"
        (blur)="handleBlur()"
      />
    </mat-date-range-input>

    <mat-datepicker-toggle matIconSuffix [for]="rangePicker" />

    <mat-date-range-picker #rangePicker />
  </mat-form-field>
}
